import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Target, Users, Award, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const features = [
    {
      icon: Target,
      title: 'Foco em Resultados',
      description: 'Desenvolvemos soluções que entregam valor real e impulsionam o crescimento do seu negócio.',
    },
    {
      icon: Users,
      title: 'Parceria Dedicada',
      description: 'Trabalhamos lado a lado com você, entendendo suas necessidades e objetivos.',
    },
    {
      icon: Award,
      title: 'Qualidade Premium',
      description: 'Código limpo, design moderno e as melhores práticas de desenvolvimento.',
    },
    {
      icon: TrendingUp,
      title: 'Escalabilidade',
      description: 'Soluções preparadas para crescer junto com seu negócio.',
    },
  ];

  return (
    <section id="sobre" className="py-24 bg-white" ref={ref} aria-label="Sobre a PixelMatos">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-semibold text-primary-600 uppercase tracking-wide mb-3">
            Sobre Nós
          </h2>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transformamos <strong className="text-gradient">visões</strong> em soluções digitais
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A PixelMatos é especializada em criar experiências digitais excepcionais para startups e pequenas empresas que desejam crescer e se destacar no mercado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group bg-gray-50 p-6 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="bg-gradient-to-br from-primary-100 to-secondary-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="text-primary-600" size={28} />
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h4>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-20 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-2xl p-12 text-center text-white"
        >
          <h3 className="text-3xl font-bold mb-4">
            Nossa Missão
          </h3>
          <p className="text-xl text-white/90 max-w-4xl mx-auto">
            Capacitar empresas com soluções tecnológicas de ponta que não apenas atendem, mas superam expectativas. Acreditamos que cada projeto é uma oportunidade de criar algo extraordinário.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
